import { useQuery } from "@tanstack/react-query";
import { getIncorrectMappedSessions } from "../services/get-incorrect-mapped-sessions";

export function useIncorrectMappedSessions(bundleUsageId: string | null) {
  return useQuery({
    queryKey: ["incorrect-mapped-sessions", bundleUsageId],
    queryFn: () => getIncorrectMappedSessions(bundleUsageId!),
    enabled: !!bundleUsageId,
    staleTime: 1000 * 60 * 5,
  });
}
